/**
 * {{FRONTEND}}, {{Consultas Cognoware v3}}
 * Copyright (c) 2025 Cognoware Cia. Ltda.
 * Todos los derechos reservados.
 *
 * Este archivo forma parte del {{FRONTEND}} de
 * Cognoware Cia. Ltda, desarrollado conforme a los requerimientos y
 * normativas establecidos.
 */

/**
 * Guarda un token en sessionStorage para persistencia por sesión
 *
 * Almacena un valor asociado a una clave dentro del almacenamiento
 * de sesión del navegador. La información permanece disponible
 * mientras la pestaña o sesión del navegador continúe activa.
 *
 * @param {string} name - Nombre de la clave a registrar
 * @param {string} value - Valor del token a almacenar
 * @returns {void} No retorna valor
 */
export const setSessionToken = (name: string, value: string): void => {
    sessionStorage.setItem(name, value);
};

/**
 * Obtiene un token desde sessionStorage por nombre de clave
 *
 * Recupera el valor almacenado en el almacenamiento de sesión
 * usando la clave proporcionada. Si no existe un valor asociado,
 * retorna null.
 *
 * @param {string} name - Nombre de la clave a consultar
 * @returns {string | null} Token encontrado o null
 */
export const getSessionToken = (name: string): string | null => {
    return sessionStorage.getItem(name);
};

/**
 * Elimina un token de sessionStorage mediante su clave
 *
 * Remueve del almacenamiento de sesión el valor asociado
 * al nombre de clave recibido. Si la clave no existe,
 * la operación no genera error.
 *
 * @param {string} name - Nombre de la clave a eliminar
 * @returns {void} No retorna valor
 */
export const removeSessionToken = (name: string): void => {
    sessionStorage.removeItem(name);
};